// src/App.js
import React from 'react';
import './App.css';
import logo from './images/logo.jpeg';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} alt="Fast Assistant Logo" className="logo" />
        <h1>Welcome to Fast Assistant</h1>
        <p>Your One-Stop Solution for Student Support and Professional Services</p>
        <button className="cta-button">Get Started</button>
      </header>

      <section className="Services">
        <h2>Our Services</h2>
        <div className="service">
          <h3>1. Professional Resume/CV Writing</h3>
          <p>Expertly crafted resumes and LinkedIn profiles.</p>
        </div>
        <div className="service">
          <h3>2. Student Project Assistance</h3>
          <p>Help with term papers, assignments, and course works.</p>
        </div>
        <div className="service">
          <h3>3. Data Analytics</h3>
          <p>Learn data analysis from beginner to advanced levels in Excel and Power BI.</p>
        </div>
        <div className="service">
          <h3>4. Web Design Classes</h3>
          <p>Master web design for beginners, intermediate, and advanced learners.</p>
        </div>
        <div className="service">
          <h3>5. Modern Workplace Technology Training</h3>
          <p>Stay up-to-date with Microsoft 365, Power Platform, and more.</p>
        </div>
        <div className="service">
          <h3>6. Custom Solution Building</h3>
          <p>Build tailored technology solutions to meet your specific needs.</p>
        </div>
        <div className="service">
          <h3>7. Professional Design Services</h3>
          <p>High-quality UX/UI design, videography, photography, and graphic works.</p>
        </div>
        <div className="service">
          <h3>8. Digital Marketing Services</h3>
          <p>Email marketing, SEO optimization, Shopify website, and optimization, etc.</p>
        </div>
        <div className="service">
          <h3>9. IT Support</h3>
          <p>Comprehensive IT support for businesses and individuals.</p>
        </div>
        <div className="service">
          <h3>10. Other Services </h3>
          <p>Customer support, Customer support, Project management, Advertising & lead generation </p>
        </div>
      </section>

      <section className="Contact">
        <h2>Contact Us</h2>
        <p>Email: <a href="mailto:Admin@fastassistant.onmicrosoft.com">Admin@fastassistant.onmicrosoft.com</a></p>
        <p>Phone: <a href="tel:08140864252">08140864252</a>, <a href="tel:08112249928">08112249928</a></p>
      </section>
    </div>
  );
}

export default App;
